import SurveyBuilderDashboard from '@/components/surveybuilder/SurveyBuilderDashboard';
import SurveyBuilderEditor from '@/components/surveybuilder/SurveyBuilderEditor';

export default [
  {
    path: '/surveybuilder',
    name: 'SurveyBuilderDashboard',
    // meta: { requiresAuth: true, is_staff: true, action: 'view', subject: 'survey-builder' },
    meta: { requiresAuth: true },
    component: SurveyBuilderDashboard,
  },
  {
    path: '/surveybuilder/editor',
    name: 'SurveyBuilderEditor',
    // meta: { requiresAuth: true, is_staff: true, action: 'view', subject: 'survey-builder' },
    meta: { requiresAuth: true },
    component: SurveyBuilderEditor,
  },
  {
    path: '/surveybuilder/editor/:id',
    name: 'SurveyBuilderItemEditor',
    meta: { requiresAuth: true },
    component: SurveyBuilderEditor,
  },
];



// WEBPACK FOOTER //
// ./src/router/surveybuilder.js